import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import { runInAction } from "mobx";
import { useTranslation } from "react-i18next";
import styles from "../styles/dashboard.module.css";
import dashboardStore from "../store/dashboardStore.js";
import commonStore from "../../Store/marco/commonStore.js";
import { reportGenerationAPI } from "../../ReportGeneration/reportGenerationAPI.js";
// import { CompanySelect } from "./CompanySelect.js";
import CompanySelector from "../../Tools/CompanySelector.js";
import CustomTreeSelect from "../../Tools/CustomTreeSelect.js";

const DashboardHeader = inject("store")(
  observer(() => {
    const store = dashboardStore;
    const cmStore = commonStore;
    //翻譯
    const { t } = useTranslation("ActivityMain");

    const [yearOptions, setYearOptions] = useState([]);
    const [menuOpen, setMenuOpen] = useState(false);

    //取得報告書年分
    const getReportYear = async (userId, reportNum) => {
      setYearOptions([]);
      try {
        //去呼叫後端API
        const data = await reportGenerationAPI.getReportYearDropdownAPI(
          userId,
          reportNum,
        );
        setYearOptions(data);
      } catch (error) {
        setYearOptions([]);
      }
    };

    useEffect(() => {
      getReportYear(cmStore.userId, "1");
    }, [cmStore.userId]);

    useEffect(() => {
      if (store.standardId == 2) {
        store._handleSetGroupBy("scope");
      }
    }, [store.standardId]);

    useEffect(() => {
      if (cmStore.isCustomTree) {
        return;
      }

      const sourceList =
        cmStore.scopeType === "AUTH" ? cmStore.orgList : cmStore.companyList;

      if (sourceList && sourceList.length > 0) {
        const filteredList = sourceList.filter((item) => {
          const isEditable = item.nodeStatus === "editable";
          const isCompany = !item.orgType || item.orgType === "COMPANY";
          return isEditable && isCompany;
        });

        // 3. 取得過濾後的 ID 清單
        const allCompanyIds = filteredList.map(
          (c) => c.value || c.id || c.companyId,
        );
        store._handleSetSelectedCom(allCompanyIds);
        store._handleSetIntensityDefaultCom(allCompanyIds);
      }
    }, [
      cmStore.companyList,
      cmStore.isCustomTree,
      cmStore.orgList,
      cmStore.scopeType,
    ]);

    ////////如果有已經設定好的邊界設定年分 自動取第一個
    useEffect(() => {
      if (yearOptions.length > 0) {
        runInAction(() => {
          store._handleSetSelectedYear(yearOptions[0].value);
          store._handleSetSelectedStandardId(yearOptions[0].standard);
        });
        console.log("yearOptions", yearOptions);
        console.log("store.selectedYear", yearOptions[0].value);
        console.log("store.selectedStandardId", yearOptions[0].standard);
      }
    }, [yearOptions]);

    const showSharedFilters =
      store.selectedDashboardPage === 0 || store.selectedSubTab === 0;

    return (
      <div className={styles.title}>
        <div className={styles.titleLeft}>
          <h4>
            {store.selectedDashboardPage === 0
              ? t("Emission Summary")
              : t("GHG & Environmental Performance")}
          </h4>
          {store.selectedDashboardPage === 0 && store.standardId == 1 ? (
            <div className={styles.buttonGroup}>
              <button
                className={`${styles.btn} ${
                  store.groupBy === "category" ? styles.active : ""
                }`}
                onClick={() => store._handleSetGroupBy("category")}
              >
                {t("Category")}
              </button>
              <button
                className={`${styles.btn} ${
                  store.groupBy === "scope" ? styles.active : ""
                }`}
                onClick={() => store._handleSetGroupBy("scope")}
              >
                {t("Scope")}
              </button>
            </div>
          ) : null}
        </div>

        {/* 下拉式清單 */}
        <div className={styles.titleRight}>
          <div
            style={{
              borderBottomLeftRadius: 15,
              borderBottomRightRadius: 15,
              height: "100%",
            }}
          >
            {/**巢狀結構的公司下拉式選單 */}
            {showSharedFilters ? (
              <>
                {cmStore.isCustomTree ? (
                  <CustomTreeSelect
                    companyList={cmStore.companySelectorList}
                    roleId={cmStore.roleId}
                    selectedIds={store.selectedCom}
                    onChange={(ids) => {
                      store._handleSetSelectedCom(ids);
                    }}
                    sx={{
                      width: "250px",
                      height: "40px",
                      backgroundColor: "white",

                      // 👇 1. 加入這兩段，強制把外框對齊並隱藏多餘的標籤預留空間
                      "& .MuiOutlinedInput-notchedOutline": {
                        top: 0,
                      },
                      "& legend": {
                        display: "none",
                      },
                      // 如果文字偏上或偏下，可以透過調整這裡來讓他完美置中
                      "& .MuiSelect-select": {
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                        paddingY: 0, // 移除預設的上下留白
                      },
                    }}
                    dropdownMaxHeight={400}
                    defaultSelectAll={true}
                    variant="dashboard"
                  />
                ) : (
                  <CompanySelector
                    // companyOptions={cmStore.companyList}
                    companyOptions={
                      cmStore.scopeType === "AUTH"
                        ? cmStore.orgList
                        : cmStore.companyList
                    }
                    selectedCom={store.selectedCom}
                    setSelectedCom={store._handleSetSelectedCom}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                    iconColor="#555555"
                    sx={{
                      width: "250px",
                      height: "35px",
                      borderRadius: "8px",
                      backgroundColor: "white",
                      "& .MuiOutlinedInput-notchedOutline": {
                        top: 0,
                        border: "none",
                      },
                      "& legend": {
                        display: "none",
                      },
                    }}
                  />
                )}
              </>
            ) : null}
          </div>

          {store.selectedDashboardPage === 0 ? (
            <>
              {/* <select
                id="format"
                value={store.format}
                className={styles.selector}
                onChange={(e) => store._handleSetFormat(e.target.value)}
              >
                <option value="yearly">{t("Yearly")}</option>
                <option value="monthly">{t("Monthly")}</option>
              </select> */}
              {/* 年度 */}
              <select
                id="selectedYear"
                className={styles.selector}
                value={String(store.selectedYear ?? "")}
                onChange={(e) => {
                  const selectedValue = Number(e.target.value);
                  const selectedOption = yearOptions.find(
                    (item) => item.value === selectedValue,
                  );
                  runInAction(() => {
                    store._handleSetSelectedYear(selectedValue);
                    if (selectedOption) {
                      store._handleSetSelectedStandardId(
                        selectedOption.standard,
                      );
                    }
                  });
                  console.log(
                    "年分",
                    selectedValue,
                    "standard",
                    selectedOption?.standard,
                  );
                }}
              >
                {yearOptions.map((option) => (
                  <option key={option.value} value={String(option.value)}>
                    {option.label}
                  </option>
                ))}
              </select>
              {/* 月份 */}
              {store.format === "monthly" ? (
                <select
                  id="selectedMonth"
                  className={styles.selector}
                  onChange={(e) =>
                    store._handleSetSelectedMonth(e.target.value)
                  }
                >
                  {[
                    { value: "1", label: "January" },
                    { value: "2", label: "February" },
                    { value: "3", label: "March" },
                    { value: "4", label: "April" },
                    { value: "5", label: "May" },
                    { value: "6", label: "June" },
                    { value: "7", label: "July" },
                    { value: "8", label: "August" },
                    { value: "9", label: "September" },
                    { value: "10", label: "October" },
                    { value: "11", label: "November" },
                    { value: "12", label: "December" },
                  ].map((month) => (
                    <option key={month.value} value={month.value}>
                      {t(month.label)}
                    </option>
                  ))}
                </select>
              ) : null}
            </>
          ) : null}
          {/* 年度月份 */}

          {/* AR5還是AR6 */}
          {showSharedFilters ? (
            <select
              id="gwpId"
              className={styles.selector}
              value={store.gwpId}
              onChange={(e) => store._handleSetGwpId(e.target.value)}
            >
              <option value="3">AR6</option>
              <option value="2">AR5</option>
            </select>
          ) : null}

          {store.selectedDashboardPage === 0 ? (
            <>
              <div className={styles.buttonGroup}>
                <button
                  className={`${styles.btn} ${
                    store.unit === "20" ? styles.active : ""
                  }`}
                  onClick={() => store._handleSetUnit("20")}
                >
                  kgCo2e
                </button>
                <button
                  className={`${styles.btn} ${
                    store.unit === "21" ? styles.active : ""
                  }`}
                  onClick={() => store._handleSetUnit("21")}
                >
                  tCo2e
                </button>
              </div>
            </>
          ) : null}
        </div>
      </div>
    );
  }),
);

export default DashboardHeader;
